import { Component, OnInit, Input, OnChanges, EventEmitter, Output, SimpleChange, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { ToastaService } from 'ngx-toasta';
import { Observable, throwError, Observer, observable } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { DialogCatAC } from './catautocompleteAdd.component';
import { DialogCatACContacto } from './catAutocompleteAddContacto.component';


@Component({
  selector: 'cat-autocomplete',
  templateUrl: './catautocomplete.component.html',  
  encapsulation: ViewEncapsulation.None
})
export class CatAutoComplete implements OnInit, OnChanges {
  private connectSvc;
  public showAddButton: boolean = false;
  private text: string = '';
  @Input() labelAppearance: string;
  @Input() label: string;
  @Input() placeholder : String;
  @Input() data : any[];
  @Input() displayValue : String;
  @Input() acValue : any;
  @Input() dataSourceFunction : any;
  @Input() disabled : boolean = false;
  @Input() type: any = {};
  @Input() padreId: number = -1;
  @Input() padreName: string = "";
  @Input() HideAddButton = false;
  @Input() HideSearchButton = false;

  /*** 
  @required Indica si el campo debe ser marcado como requerido
  ***/
  @Input() required: boolean = false;

  @Output() acValueChange = new EventEmitter<any>();
  @ViewChild('autoCompleteInput', {read: MatAutocompleteTrigger }) autoCompleteInput: MatAutocompleteTrigger;

  public filteredOptions : Observable<any[]>
  public autocompleteFormControl = new FormControl();
  private opt : {};
  public icons : any = { add : faPlusCircle };
  constructor(public dialog: MatDialog, httpConn: httpConnect,private toastaService: ToastaService) {
    this.connectSvc = httpConn;
    this.labelAppearance = this.labelAppearance || 'mat-form-field-no-label';
   }

  ngOnInit() {
      this.data = this.data || [];
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }){   
    this.dataSourceFunction = this.FiltraValores;  
     if(changes.data){
         this.InicializaFiltrosAC();
     }
     let validaID = !!this.acValue && this.acValue.hasOwnProperty('id') ? this.acValue.id != null : true;
     let validaValue = !!this.acValue && this.acValue.hasOwnProperty('value') ? this.acValue.value != '' : true;
     if(changes.acValue && this.acValue != {} && validaID && validaValue){
       if (this.data) {
        if (this.acValue) this.autocompleteFormControl.setValue(this.data.find(d => d[this.displayValue.toString()] == this.acValue[this.displayValue.toString()]));
        else this.autocompleteFormControl.setValue({});
        this.showAddButton = false;
      }
    }
  }

  ngAfterViewInit(){
      
  }

  public clear(){
    this.autoCompleteInput.closePanel();
    this.autocompleteFormControl.setValue(null);
  }

  public ActualizaAutocomplete(ev:any){
    this.opt = ev.option.value;
    this.acValueChange.emit(this.opt);
  }

  public InicializaFiltrosAC() {
      this.filteredOptions = this.autocompleteFormControl.valueChanges.pipe(
          startWith(''),
          map(p => typeof p === 'string' || !p ? p : p[this.displayValue.toString()]),
          switchMap(p => p ? this.FiltraValores(p) : []),
          catchError(err => { /* 2022-02-20 (aaangeles) */
            this.toastaService.warning({ title : '¡Advertencia!', msg : err['message'], showClose : true, showDuration : false, theme : "default" , timeout : 7000 }); 
            return [];
          })
      )
  }

  displayAC(p?: any): string | undefined {
    return p ? p[this.displayValue.toString()] : undefined;
  }

  public OnBlur(){
    setTimeout(() => {
      if(typeof this.autocompleteFormControl.value === "string"){
        if(this.autocompleteFormControl.value != ''){          
          if (this.data.length > 0){
            let val = this.autocompleteFormControl.value.toString().toLowerCase();
            this.acValue = this.dataSourceFunction ? this.data[0] : this.data.filter(s => s[this.displayValue.toString()].toLowerCase().includes(val))[0];
          } 
          else {
            this.acValue = {};
          }               
        }
        else {
          this.acValue = {};
        }
        this.autocompleteFormControl.setValue(Object.keys(this.acValue).length > 0 ? this.acValue : '');
        this.acValueChange.emit(this.acValue);        
        this.showAddButton = false;
      }  
    }, 300);  
  }

  public MostrarDialog() {
    //this.displayToasta = false;
    let dialogRef: any;
    if (this.type.tblName == 'socorros_contacto') {
      dialogRef = this.dialog.open(DialogCatACContacto, {
        data: { type: this.type, text: this.text, cancel: false },
        // panelClass: "dialog-responsive-cat",
        // height: '62vh',
      });
    }
    else {
      dialogRef = this.dialog.open(DialogCatAC, {
        data: { type: this.type, text: this.text, cancel: false, padreId: this.padreId },
        panelClass: "dialog-responsive-cat",
        // height: '32vh',
      });
    }

    dialogRef.afterClosed()
    .subscribe(result => {
      if (!!result) {
        //this.acValue = result;
        this.data = [result];
        this.autocompleteFormControl.setValue(result); 
        this.showAddButton = false;       
        this.acValueChange.emit(result);
      }
    });
  }

  FiltraValores(filtro : string) : Observable<any>{  
    if(this.padreName.length > 0)
    {
      if(this.padreId == null){
          let message = "Campo dependiente por favor capturar el campo " + this.padreName + " antes de continuar."
          this.toastaService.warning({ title : '¡Advertencia!', msg : message, showClose : true, showDuration : false, theme : "default" , timeout : 7000 });
          let Observer:Observable<any> = new Observable<any>();
          return Observer; 
      }
    }

    this.showAddButton = true;     
    this.text = filtro;
    let params = { catalogo: this.type.tblName, value: filtro, padreId:this.padreId}
    return this.connectSvc.postAPI("General", "ACCatalogos_ConsultaXDesc", params)
      .pipe(
        map((result: any) => {
          let res = result.response;
          this.data = res;
          return res;
        })
        ,catchError(err => {         
          return throwError(err.error);
        })
      )
  }    
}
